// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mapping Profile Section */
.mapping-profile-header {
  display: flex !important;
  align-items: center !important;
  gap: 8px;
  position: relative;
  width: 100%;
  overflow: visible !important;
  flex-wrap: nowrap !important;
}

/* Bootstrap Tabs Customization */
.mapping-profile-tabs {
  flex: 0 1 auto;
  overflow: visible !important;
  min-width: 0;
  max-width: calc(100% - 200px);
}

.mapping-profile-tabs .nav {
  width: auto;
}

/* Individual tab styling */
.mapping-profile-tabs .nav-link {
  color: #64748b;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  background: transparent;
  position: relative;
  width: 200px ;
  flex-shrink: 0 !important;
  white-space: nowrap !important;
  overflow: hidden;
  padding: 0px !important;
}

.mapping-profile-tabs .nav-link:hover {
  color: #3b82f6;
  background-color: #f8fafc;
  border-bottom-color: #93c5fd;
}

.mapping-profile-tabs .nav-link.active {
  color: #3b82f6;
  background-color: #eff6ff;
  font-weight: 600;
}

/* Tab title with ellipsis */
.tab-title-wrapper {
  display: block;
  max-width: 200px;
  overflow: hidden;
}

.tab-title-text {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 12px 12px;
}

/* Default badge in tab */
.default-badge-tab {
  font-size: 11px;
  font-weight: 500;
  color: #10b981;
  margin-left: 4px;
  white-space: nowrap;
}

/* Add new tab button */
.add-new-tab-button {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 40px;
  padding: 8px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.add-new-tab-button:hover {
  background-color: #f8fafc;
  border-color: #3b82f6;
}

.add-new-tab-button:hover .plus-icon path {
  stroke: #2563eb;
}

.add-new-tab-button:active {
  transform: scale(0.95);
}

.plus-icon {
  display: block;
}

/* Responsive behavior */
@media (max-width: 768px) {
  .mapping-profile-tabs .nav-link {
    max-width: 180px;
    padding: 10px 12px;
    font-size: 13px;
  }

  .add-new-tab-button {
    min-width: 36px;
    height: 36px;
  }
}

/* Overflow Tabs Dropdown */
.overflow-tabs-dropdown {
  flex-shrink: 0;
  position: relative;
}

.dropdown-toggle-button {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 500;
  border: 1px solid #e2e8f0;
  color: #64748b;
  background-color: #ffffff;
  transition: all 0.2s ease;
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;
}

.dropdown-toggle-button:hover {
  background-color: #f8fafc;
  border-color: #3b82f6;
  color: #3b82f6;
}

.dropdown-toggle-button:focus {
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(59, 130, 246, 0.25);
}

.dropdown-toggle-button:active {
  transform: scale(0.98);
}

.dropdown-arrow-down {
  transition: transform 0.2s ease;
}

.dropdown-arrow-up {
  transition: transform 0.2s ease;
  transform: rotate(180deg);
}

.dropdown-menu-custom {
  position: fixed;
  z-index: 99999;
  min-width: 200px;
  max-height: 300px;
  overflow-y: auto;
  margin: 0;
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  padding: 4px;
  animation: dropdownFadeIn 0.15s ease-out;
}

@keyframes dropdownFadeIn {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.dropdown-item-custom {
  font-size: 14px;
  padding: 8px 12px;
  border-radius: 4px;
  color: #64748b;
  transition: all 0.15s ease;
  cursor: pointer;
  text-decoration: none;
  display: block;
  width: 100%;
  text-align: left;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}

.dropdown-item-custom:hover {
  background-color: #f8fafc;
  color: #3b82f6;
  text-decoration: none;
}

.dropdown-item-custom.active {
  background-color: #eff6ff;
  color: #3b82f6;
  font-weight: 500;
}

.default-badge-dropdown {
  font-size: 11px;
  font-weight: 500;
  color: #10b981;
  margin-left: 4px;
  white-space: nowrap;
}

/* Focus styles for accessibility */
.mapping-profile-tabs .nav-link:focus-visible {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
  border-radius: 4px;
}

.add-new-tab-button:focus-visible {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

.overflow-tabs-dropdown .dropdown-toggle:focus-visible {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Integrations/HubspotIntegration/components/MappingTab/MappingProfile.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA,iCAAiC;AACjC;EACE,cAAc;EACd,4BAA4B;EAC5B,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,wBAAwB;AACxB;EACE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA,2BAA2B;AAC3B;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iDAAiD;AACnD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,yBAAyB;EACzB,yBAAyB;EACzB,mFAAmF;EACnF,kBAAkB;EAClB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB","sourcesContent":["/* Mapping Profile Section */\n.mapping-profile-header {\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px;\n  position: relative;\n  width: 100%;\n  overflow: visible !important;\n  flex-wrap: nowrap !important;\n}\n\n/* Bootstrap Tabs Customization */\n.mapping-profile-tabs {\n  flex: 0 1 auto;\n  overflow: visible !important;\n  min-width: 0;\n  max-width: calc(100% - 200px);\n}\n\n.mapping-profile-tabs .nav {\n  width: auto;\n}\n\n/* Individual tab styling */\n.mapping-profile-tabs .nav-link {\n  color: #64748b;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  background: transparent;\n  position: relative;\n  width: 200px ;\n  flex-shrink: 0 !important;\n  white-space: nowrap !important;\n  overflow: hidden;\n  padding: 0px !important;\n}\n\n.mapping-profile-tabs .nav-link:hover {\n  color: #3b82f6;\n  background-color: #f8fafc;\n  border-bottom-color: #93c5fd;\n}\n\n.mapping-profile-tabs .nav-link.active {\n  color: #3b82f6;\n  background-color: #eff6ff;\n  font-weight: 600;\n}\n\n/* Tab title with ellipsis */\n.tab-title-wrapper {\n  display: block;\n  max-width: 200px;\n  overflow: hidden;\n}\n\n.tab-title-text {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding: 12px 12px;\n}\n\n/* Default badge in tab */\n.default-badge-tab {\n  font-size: 11px;\n  font-weight: 500;\n  color: #10b981;\n  margin-left: 4px;\n  white-space: nowrap;\n}\n\n/* Add new tab button */\n.add-new-tab-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 40px;\n  height: 40px;\n  padding: 8px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  background-color: #ffffff;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.add-new-tab-button:hover {\n  background-color: #f8fafc;\n  border-color: #3b82f6;\n}\n\n.add-new-tab-button:hover .plus-icon path {\n  stroke: #2563eb;\n}\n\n.add-new-tab-button:active {\n  transform: scale(0.95);\n}\n\n.plus-icon {\n  display: block;\n}\n\n/* Responsive behavior */\n@media (max-width: 768px) {\n  .mapping-profile-tabs .nav-link {\n    max-width: 180px;\n    padding: 10px 12px;\n    font-size: 13px;\n  }\n\n  .add-new-tab-button {\n    min-width: 36px;\n    height: 36px;\n  }\n}\n\n/* Overflow Tabs Dropdown */\n.overflow-tabs-dropdown {\n  flex-shrink: 0;\n  position: relative;\n}\n\n.dropdown-toggle-button {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 40px;\n  padding: 8px 12px;\n  font-size: 13px;\n  font-weight: 500;\n  border: 1px solid #e2e8f0;\n  color: #64748b;\n  background-color: #ffffff;\n  transition: all 0.2s ease;\n  border-radius: 6px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.dropdown-toggle-button:hover {\n  background-color: #f8fafc;\n  border-color: #3b82f6;\n  color: #3b82f6;\n}\n\n.dropdown-toggle-button:focus {\n  outline: none;\n  box-shadow: 0 0 0 0.2rem rgba(59, 130, 246, 0.25);\n}\n\n.dropdown-toggle-button:active {\n  transform: scale(0.98);\n}\n\n.dropdown-arrow-down {\n  transition: transform 0.2s ease;\n}\n\n.dropdown-arrow-up {\n  transition: transform 0.2s ease;\n  transform: rotate(180deg);\n}\n\n.dropdown-menu-custom {\n  position: fixed;\n  z-index: 99999;\n  min-width: 200px;\n  max-height: 300px;\n  overflow-y: auto;\n  margin: 0;\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  border-radius: 6px;\n  padding: 4px;\n  animation: dropdownFadeIn 0.15s ease-out;\n}\n\n@keyframes dropdownFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.dropdown-item-custom {\n  font-size: 14px;\n  padding: 8px 12px;\n  border-radius: 4px;\n  color: #64748b;\n  transition: all 0.15s ease;\n  cursor: pointer;\n  text-decoration: none;\n  display: block;\n  width: 100%;\n  text-align: left;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n}\n\n.dropdown-item-custom:hover {\n  background-color: #f8fafc;\n  color: #3b82f6;\n  text-decoration: none;\n}\n\n.dropdown-item-custom.active {\n  background-color: #eff6ff;\n  color: #3b82f6;\n  font-weight: 500;\n}\n\n.default-badge-dropdown {\n  font-size: 11px;\n  font-weight: 500;\n  color: #10b981;\n  margin-left: 4px;\n  white-space: nowrap;\n}\n\n/* Focus styles for accessibility */\n.mapping-profile-tabs .nav-link:focus-visible {\n  outline: 2px solid #3b82f6;\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n.add-new-tab-button:focus-visible {\n  outline: 2px solid #3b82f6;\n  outline-offset: 2px;\n}\n\n.overflow-tabs-dropdown .dropdown-toggle:focus-visible {\n  outline: 2px solid #3b82f6;\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
